import { render, staticRenderFns } from "./LeadStatusesConfig.vue?vue&type=template&id=c2d66e16&scoped=true&"
import script from "./LeadStatusesConfig.vue?vue&type=script&lang=js&"
export * from "./LeadStatusesConfig.vue?vue&type=script&lang=js&"
import style0 from "./LeadStatusesConfig.vue?vue&type=style&index=0&id=c2d66e16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d66e16",
  null
  
)

export default component.exports